import styled, { keyframes } from "styled-components";

export default function () {
  return <Loader />;
}

const Load7 = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
const Loader = styled.div`
  margin: 60px auto;
  font-size: 4px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.1);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.3);
  border-left: 1.1em solid rgba(255, 255, 255, 0.4);
  transform: translateZ(0);
  animation: ${Load7} 1.1s infinite linear;
  &, :after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
`;
